import { FIELD_LIMITS } from '../constants/limits';
export const PASSWORD_POLICY_PARAMS = {
    min: FIELD_LIMITS.productPassword.min,
    max: FIELD_LIMITS.productPassword.max,
};
/** Büyük harf: küçük hâli kendisinden FARKLI olan bir karakter var mı. */
function hasUppercase(password) {
    for (const char of password) {
        if (char !== char.toLowerCase() && char === char.toUpperCase())
            return true;
    }
    return false;
}
/** Özel karakter: harf de rakam da boşluk da OLMAYAN bir karakter var mı. */
function hasSymbol(password) {
    for (const char of password) {
        const isLetter = char.toLowerCase() !== char.toUpperCase();
        const isDigit = char >= '0' && char <= '9';
        if (!isLetter && !isDigit && char.trim() !== '')
            return true;
    }
    return false;
}
/**
 * Uzunluk kuralları — iki politika da (ürün ve personel) aynı ÖLÇÜYÜ kullanır,
 * sayıları kendi `params`ından okur. Ölçü paylaşılır, sınır paylaşılmaz.
 */
export const PASSWORD_MIN_LENGTH_RULE = {
    id: 'minLength',
    labelKey: 'auth.password.ruleMinLength',
    messageKey: 'auth.password.passwordTooShort',
    test: (password, params) => password.length >= params.min,
};
export const PASSWORD_MAX_LENGTH_RULE = {
    id: 'maxLength',
    labelKey: 'auth.password.ruleMaxLength',
    messageKey: 'auth.password.passwordTooLong',
    listedOnlyWhenUnmet: true,
    test: (password, params) => password.length <= params.max,
};
/** Ürün şifresi — sıra, gönderim reddinde hangi cümlenin yazılacağını belirler. */
export const PRODUCT_PASSWORD_POLICY = {
    params: PASSWORD_POLICY_PARAMS,
    rules: [
        PASSWORD_MIN_LENGTH_RULE,
        PASSWORD_MAX_LENGTH_RULE,
        {
            id: 'uppercase',
            labelKey: 'auth.password.ruleUppercase',
            messageKey: 'auth.password.passwordNeedsUppercase',
            test: (password) => hasUppercase(password),
        },
        {
            id: 'symbol',
            labelKey: 'auth.password.ruleSymbol',
            messageKey: 'auth.password.passwordNeedsSymbol',
            test: (password) => hasSymbol(password),
        },
    ],
};
/** Kontrol listesinin girdisi: her kural için sağlandı mı + çizilir mi. */
export function evaluatePasswordRules(password, policy = PRODUCT_PASSWORD_POLICY) {
    return policy.rules.map((rule) => {
        const met = rule.test(password, policy.params);
        return {
            id: rule.id,
            labelKey: rule.labelKey,
            params: policy.params,
            met,
            listed: !(rule.listedOnlyWhenUnmet === true && met),
            violated: rule.listedOnlyWhenUnmet === true && !met,
        };
    });
}
/**
 * DUYURU İMZASI — maddelerin sağlanma durumunun özeti. Kontrol listesi
 * (web `@icebreaker/ui` ve mobil `PasswordRuleList`) ekran okuyucuya yalnız bu
 * imza DEĞİŞİNCE duyuru yapar, her tuşta değil. İki platform aynı kararı verir;
 * mantık burada tek kopya durur (CLAUDE.md: web ve mobil arasında çoğaltılan
 * iş mantığı `packages/shared`a taşınır, tech-lead B-29).
 */
export function passwordRuleSignature(statuses) {
    return statuses.map((status) => `${status.id}:${status.met ? 1 : 0}`).join('|');
}
/** Önceki imzaya göre sağlanma durumu DEĞİŞEN maddeler (duyurulacak olanlar). */
export function changedPasswordRules(previousSignature, statuses) {
    const before = new Map(previousSignature
        .split('|')
        .filter((part) => part !== '')
        .map((part) => [part.slice(0, part.lastIndexOf(':')), part.endsWith(':1')]));
    return statuses.filter((status) => before.get(status.id) !== status.met);
}
/** Politikanın kararı: ilk sağlanmayan kuralın cümlesi, yoksa geçer. */
export function checkPasswordRules(password, policy) {
    const failed = policy.rules.find((rule) => !rule.test(password, policy.params));
    return {
        ok: failed === undefined,
        messageKey: failed ? failed.messageKey : null,
        params: policy.params,
    };
}
export function checkPasswordPolicy(password) {
    return checkPasswordRules(password, PRODUCT_PASSWORD_POLICY);
}
//# sourceMappingURL=password-policy.js.map